const TOOLBAR_BREAKPOINTS = {
  STRIKE_INDENT_CLEAR: 670,
  IMAGE_GIF: 590,
  MENTION_LINK: 490,
  NEXT_ONE: 430,
  CHECKBOX_ETC: 380,
};

export default TOOLBAR_BREAKPOINTS;
